export const ADD_FILES = 'ADD_FILES'
export const ADD_FOLDER = 'ADD_FOLDER'
export const REMOVE_DOCUMENT = 'REMOVE_DOCUMENT'
export const RESET_SELECTED_DOCUMENTS = 'RESET_SELECTED_DOCUMENTS'
export const SET_IS_OPEN = 'SET_IS_OPEN'
